import React from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber} from 'react-intl';


/**
 * Wrapping formatted number for centralized injection *
 *
 */
function Number(props) {

    return (
        <FormattedNumber {...props}/>
    );
}


Number.propTypes = {
    ...FormattedNumber.propTypes,
    value: PropTypes.any.isRequired
};

Number.defaultProps = {
    ...FormattedNumber.defaultProps
};


export default Number;
